import React, { useEffect, useContext, useState, useCallback, useRef } from 'react';

import './index.pc.scss';

import PresentPC from 'components/pages/Cond/PresentPC';
import PresentSP from 'components/pages/Cond/PresentSP';

import { DROPDOWN_INITIAL_ITEM, CHOICES_MAP,
  CUSTOM_ERROR_MESSAGES, 
} from 'utils/constant';
import { 
  isSchemaValid, 
  isCustomValid,
  useWindowDimensions,
  calcSalary,
  calcSalaryCoefficient,
  useDirectTransCheck,
  sortErrors,
  useIECheck,
  postHeightToParent,
} from 'utils';

import AppContext from 'fluxes/context';
import { UPDATE_COND, CHANGE_VALID } from 'fluxes/actions';

const Cond = () => {
  const path = window.location.pathname;
  const { state, dispatch } = useContext(AppContext);
  useDirectTransCheck({ state });

  const today = new Date();
  const tommorow = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);

  const firstToDate = state.toDate ? new Date(state.toDate) : '';
  const firstFromDate = state.fromDate ? new Date(state.fromDate) : '';

  const [ fromDate, setFromDate ] = useState(firstFromDate);
  const [ toDate, setToDate ] = useState(firstToDate);
  const [ workStyle, setWorkStyle ] = useState(state.workStyle);
  const [ workStyleKbn, setWorkStyleKbn ] = useState(state.workStyleKbn);
  const [ dayOfTheWeek, setDayOfTheWeek ] = useState(state.dayOfTheWeek);
  const [ fixedStartHour, setFixedStartHour ] = useState(state.fixedStartHour);
  const [ fixedStartMin, setFixedStartMin ] = useState(state.fixedStartMin);
  const [ fixedEndHour, setFixedEndHour ] = useState(state.fixedEndHour);
  const [ fixedEndMin, setFixedEndMin ] = useState(state.fixedEndMin);
  const [ fixedRestTime, setFixedRestTime ] = useState(state.fixedRestTime);
  const [ earlyShiftStartHour, setEarlyShiftStartHour ] = useState(state.earlyShiftStartHour);
  const [ earlyShiftStartMin, setEarlyShiftStartMin ] = useState(state.earlyShiftStartMin);
  const [ earlyShiftEndHour, setEarlyShiftEndHour ] = useState(state.earlyShiftEndHour);
  const [ earlyShiftEndMin, setEarlyShiftEndMin ] = useState(state.earlyShiftEndMin);
  const [ earlyShiftRestTime, setEarlyShiftRestTime ] = useState(state.earlyShiftRestTime);
  const [ dayShiftStartHour, setDayShiftStartHour ] = useState(state.dayShiftStartHour);
  const [ dayShiftStartMin, setDayShiftStartMin ] = useState(state.dayShiftStartMin);
  const [ dayShiftEndHour, setDayShiftEndHour ] = useState(state.dayShiftEndHour);
  const [ dayShiftEndMin, setDayShiftEndMin ] = useState(state.dayShiftEndMin);
  const [ dayShiftRestTime, setDayShiftRestTime ] = useState(state.dayShiftRestTime);
  const [ lateShiftStartHour, setLateShiftStartHour ] = useState(state.lateShiftStartHour);
  const [ lateShiftStartMin, setLateShiftStartMin ] = useState(state.lateShiftStartMin);
  const [ lateShiftEndHour, setLateShiftEndHour ] = useState(state.lateShiftEndHour);
  const [ lateShiftEndMin, setLateShiftEndMin ] = useState(state.lateShiftEndMin);
  const [ lateShiftRestTime, setLateShiftRestTime ] = useState(state.lateShiftRestTime);
  const [ nightShiftStartHour, setNightShiftStartHour ] = useState(state.nightShiftStartHour);
  const [ nightShiftStartMin, setNightShiftStartMin ] = useState(state.nightShiftStartMin);
  const [ nightShiftEndHour, setNightShiftEndHour ] = useState(state.nightShiftEndHour);
  const [ nightShiftEndMin, setNightShiftEndMin ] = useState(state.nightShiftEndMin);
  const [ nightShiftRestTime, setNightShiftRestTime ] = useState(state.nightShiftRestTime);
  const [ minBusinessDay, setMinBusinessDay ] = useState(state.minBusinessDay);
  const [ maxBusinessDay, setMaxBusinessDay ] = useState(state.maxBusinessDay);
  const [ canCommuteByCar, setCanCommuteByCar ] = useState(state.canCommuteByCar);
  const [ hourSalary, setHourSalary ] = useState(state.hourSalary);
  const [ suggestHourSalary ] = useState(state.suggestHourSalary);
  const [ suggestHourSalaryDisp, setSuggestHourSalaryDisp ] = useState({});
  const { toString } = Object.prototype;
  const typeOf = ((obj) => {
    return toString.call(obj).slice(8, -1).toLowerCase();
  });
  const [ firstMinToDate ] = useState(typeOf(firstFromDate) === 'date' ? 
    new Date(firstFromDate.getFullYear(), firstFromDate.getMonth(), firstFromDate.getDate() + 31)
    : new Date(tommorow.getFullYear(), tommorow.getMonth(), tommorow.getDate() + 31));
  const [ minToDate, setMinToDate ] = useState(firstMinToDate);
  const [ pendingToDateFlag, setPendingToDateFlag ] = useState(!!state.pendingToDateFlag);
  const [ pendingFromDateFlag, setPendingFromDateFlag ] = useState(!!state.pendingFromDateFlag);
  const [ calToPlaceholder, setCalToPlaceholder ] = useState(pendingToDateFlag ? '未定' : '');
  const [ calFromPlaceholder, setCalFromPlaceholder ] = useState(pendingToDateFlag ? '未定' : '');
  const [ freeComment, setFreeComment ] = useState(state.freeComment);
  const [ experience ] = useState(state.experience);
  const [ qualification ] = useState(state.qualification);
  const [ qualificationText ] = useState(state.qualificationText);
  const pageEl = useRef(null);
  // 入力チェック
  const initialValid = { valid: state.validMap[path], errorMessages: [] };
  const [ valids, setValids ] = useState({
    schema: initialValid,
    checkSyuugyouKikan: initialValid,
    checkDayOfTheWeek: initialValid,
    checkBusinessDay: initialValid,
  });
  const [ earlyShiftValids, setEarlyShiftValids ] = useState({
    checkOver8HoursEarlyShift: initialValid,
    checkLessThan0HourEarlyShift: initialValid,
    checkRestTimeEarlyShift: initialValid,
  });
  const [ dayShiftValids, setDayShiftValids ] = useState({
    checkOver8HoursDayShift: initialValid,
    checkLessThan0HourDayShift: initialValid,
    checkRestTimeDayShift: initialValid,
  });
  const [ lateShiftValids, setLateShiftValids ] = useState({
    checkOver8HoursLateShift: initialValid,
    checkLessThan0HourLateShift: initialValid,
    checkRestTimeLateShift: initialValid,
  });
  const [ nightShiftValids, setNightShiftValids ] = useState({
    checkOver8HoursNightShift: initialValid,
    checkLessThan0HourNightShift: initialValid,
    checkRestTimeNightShift: initialValid,
  });
  const [ fixedValids, setFixedValids ] = useState({
    checkWeek20hourFixed: initialValid,
    checkOver8HoursFixed: initialValid,
    checkLessThan0HourFixed: initialValid,
    checkRestTimeFixed: initialValid,
  });
  // 初期入力チェック設定
  const [ isShowError, setIsShowError ] = useState({
    workStyle: false,
    dayOfTheWeek: true,
    workStyleKbn: false,
    syuugyouKikan: true,
    syuugyouTimeFixed: true,
    syuugyouTimeEarlyShift: true,
    syuugyouTimeDayShift: true,
    syuugyouTimeLateShift: true,
    syuugyouTimeNightShift: true,
    restTimeFixed: true,
    restTimeEarlyShift: true,
    restTimeDayShift: true,
    restTimeLateShift: true,
    restTimeNightShift: true,
    hourSalary: false,
    businessDay: true,
    canCommuteByCar: false,
    freeComment: false,
  });

  const [ warn, setWarn ] = useState({});

  // エラーの画面表示で利用する値
  let valid = Object.keys(valids).every(key => valids[key].valid); 
  if(workStyle === '01'){
    valid = Object.keys(fixedValids).every(key => fixedValids[key].valid) && valid; 
  }
  if(workStyle === '02'){
    if(workStyleKbn.includes('02')){
      valid = Object.keys(earlyShiftValids).every(key => earlyShiftValids[key].valid) && valid;
    }
    if(workStyleKbn.includes('03')){
      valid = Object.keys(dayShiftValids).every(key => dayShiftValids[key].valid) && valid;
    }
    if(workStyleKbn.includes('04')){
      valid = Object.keys(lateShiftValids).every(key => lateShiftValids[key].valid) && valid;
    }
    if(workStyleKbn.includes('05')){
      valid = Object.keys(nightShiftValids).every(key => nightShiftValids[key].valid) && valid;
    }
  }
  const dispErrors = useCallback(() => {
    const { schema, checkSyuugyouKikan, checkDayOfTheWeek, checkBusinessDay } = valids;
    const { checkRestTimeEarlyShift, checkOver8HoursEarlyShift, checkLessThan0HourEarlyShift } = earlyShiftValids;
    const { checkRestTimeDayShift, checkOver8HoursDayShift, checkLessThan0HourDayShift } = dayShiftValids;
    const { checkRestTimeLateShift, checkOver8HoursLateShift, checkLessThan0HourLateShift } = lateShiftValids;
    const { checkRestTimeNightShift, checkOver8HoursNightShift, checkLessThan0HourNightShift } = nightShiftValids;
    const { checkRestTimeFixed, checkOver8HoursFixed, checkWeek20hourFixed, checkLessThan0HourFixed } = fixedValids;
    const errors = sortErrors([
      ...schema.errorMessages,
      ...checkSyuugyouKikan.errorMessages,
      ...checkDayOfTheWeek.errorMessages,
      ...checkBusinessDay.errorMessages,
      ...checkRestTimeEarlyShift.errorMessages,
      ...checkOver8HoursEarlyShift.errorMessages,
      ...checkLessThan0HourEarlyShift.errorMessages,
      ...checkRestTimeDayShift.errorMessages,
      ...checkOver8HoursDayShift.errorMessages,
      ...checkLessThan0HourDayShift.errorMessages,
      ...checkRestTimeLateShift.errorMessages,
      ...checkOver8HoursLateShift.errorMessages,
      ...checkLessThan0HourLateShift.errorMessages,
      ...checkRestTimeNightShift.errorMessages,
      ...checkOver8HoursNightShift.errorMessages,
      ...checkLessThan0HourNightShift.errorMessages,
      ...checkRestTimeFixed.errorMessages,
      ...checkOver8HoursFixed.errorMessages,
      ...checkLessThan0HourFixed.errorMessages,
      ...checkWeek20hourFixed.errorMessages,
    ]);
    /* 前の
      const errors = sortErrors(Object.keys(valids).map(key => valids[key].errorMessages).flat());
    */
    const errorMap = errors.reduce((obj, error) => {
      const { target, message } = error;
      if(!isShowError[target] || Object.keys(obj).includes(target)) return obj;
      return { ...obj, [target]: message };
    }, {});
    console.log({ errorMap });
    return errorMap;
  }, [ dayShiftValids, earlyShiftValids, fixedValids, isShowError, lateShiftValids, nightShiftValids, valids ]);

  // SP判定
  const { width } = useWindowDimensions();
  const isIE = useIECheck();
  const isSp = width <= 640 && !isIE;

  let {
    minBusinessDayList,
    maxBusinessDayList,
    dayOfTheWeekList,
    startHourList,
    startMinList,
    endHourList,
    endMinList,
    restTimeList,
    canCommuteByCarList,
  } = CHOICES_MAP;
  const {
    workStyleList,
    workStyleKbnList,
  } = CHOICES_MAP;

  // SP用にダミーを削除
  const changeSpList = (list) => {
    return list.filter(item => item.value !== DROPDOWN_INITIAL_ITEM.value);
  };

  if (isSp) {
    minBusinessDayList = changeSpList(minBusinessDayList);
    maxBusinessDayList = changeSpList(maxBusinessDayList);
    dayOfTheWeekList = changeSpList(dayOfTheWeekList);
    startHourList = changeSpList(startHourList);
    startMinList = changeSpList(startMinList);
    endHourList = changeSpList(endHourList);
    endMinList = changeSpList(endMinList);
    restTimeList = changeSpList(restTimeList);
    canCommuteByCarList = changeSpList(canCommuteByCarList);
  }

  // 入力チェック
  useEffect(()=> {

    const validateion = async () => {
      // エラーチェックを実行
      let [ isValid, newErrorMessages ] = isSchemaValid({
        target: {
          fromDate,
          toDate,
          workStyle,
          minBusinessDay,
          maxBusinessDay,
          dayOfTheWeek,
          canCommuteByCar,
          hourSalary,
          suggestHourSalary,
          freeComment,
        },
      });
      if(workStyle === '01'){// 固定勤務
        [ isValid, newErrorMessages ] = isSchemaValid({
          target: {
            fromDate,
            toDate,
            workStyle,
            minBusinessDay,
            maxBusinessDay,
            dayOfTheWeek,
            canCommuteByCar,
            hourSalary,
            suggestHourSalary,
            freeComment,
            fixedStartHour,
            fixedStartMin,
            fixedEndHour,
            fixedEndMin,
            fixedRestTime,
          },
        });
      }else if (workStyle === '02'){// シフト勤務
        [ isValid, newErrorMessages ] = isSchemaValid({
          target: {
            fromDate,
            toDate,
            workStyle,
            workStyleKbn,
            minBusinessDay,
            maxBusinessDay,
            dayOfTheWeek,
            canCommuteByCar,
            hourSalary,
            suggestHourSalary,
            freeComment,
          },
        });
        if(workStyleKbn.includes('02')){// 早番
          [ isValid, newErrorMessages ] = isSchemaValid({
            target: {
              fromDate,
              toDate,
              workStyle,
              minBusinessDay,
              maxBusinessDay,
              dayOfTheWeek,
              workStyleKbn,
              canCommuteByCar,
              hourSalary,
              suggestHourSalary,
              freeComment,
              earlyShiftStartHour,
              earlyShiftStartMin,
              earlyShiftEndHour,
              earlyShiftEndMin,
              earlyShiftRestTime,
            },
          });
        }else if(workStyleKbn.includes('03')){// 日勤
          [ isValid, newErrorMessages ] = isSchemaValid({
            target: {
              fromDate,
              toDate,
              workStyle,
              minBusinessDay,
              maxBusinessDay,
              dayOfTheWeek,
              workStyleKbn,
              canCommuteByCar,
              hourSalary,
              suggestHourSalary,
              freeComment,
              dayShiftStartHour,
              dayShiftStartMin,
              dayShiftEndHour,
              dayShiftEndMin,
              dayShiftRestTime,
            },
          });
        }else if( workStyleKbn.includes('04')){// 遅番
          [ isValid, newErrorMessages ] = isSchemaValid({
            target: {
              fromDate,
              toDate,
              workStyle,
              minBusinessDay,
              maxBusinessDay,
              dayOfTheWeek,
              workStyleKbn,
              canCommuteByCar,
              hourSalary,
              suggestHourSalary,
              freeComment,
              lateShiftStartHour,
              lateShiftStartMin,
              lateShiftEndHour,
              lateShiftEndMin,
              lateShiftRestTime,
            },
          });
        }else if(workStyleKbn.includes('05')){// 夜勤
          [ isValid, newErrorMessages ] = isSchemaValid({
            target: {
              fromDate,
              toDate,
              workStyle,
              minBusinessDay,
              maxBusinessDay,
              dayOfTheWeek,
              workStyleKbn,
              canCommuteByCar,
              hourSalary,
              suggestHourSalary,
              freeComment,
              nightShiftStartHour,
              nightShiftStartMin,
              nightShiftEndHour,
              nightShiftEndMin,
              nightShiftRestTime,
            },
          });
        }
      }
      console.log('valid:schema', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { schema: { valid: isValid, errorMessages: newErrorMessages } };
      setValids(org => ({ ...org, ...newValid }));
    };
    validateion();

    // 1ヶ月あたりの金額を計算
    const moneyForDisp = num => num > 0 ? num.toLocaleString() : '-';

    // 相場金額（時給）
    const coefficient = calcSalaryCoefficient(qualification, qualificationText, experience);
    setSuggestHourSalaryDisp({
      min: moneyForDisp(calcSalary(suggestHourSalary + coefficient.min)), 
      max: moneyForDisp(calcSalary(suggestHourSalary + coefficient.max)),
    });
  }, [ minBusinessDay, maxBusinessDay, dayOfTheWeek, fromDate, hourSalary, suggestHourSalary, toDate, freeComment, qualification, qualificationText, experience, workStyle, workStyleKbn, canCommuteByCar, fixedStartHour, fixedStartMin, fixedEndHour, fixedEndMin, fixedRestTime, earlyShiftStartHour, earlyShiftStartMin, earlyShiftEndHour, earlyShiftEndMin, earlyShiftRestTime, dayShiftStartHour, dayShiftRestTime, dayShiftEndHour, dayShiftEndMin, lateShiftStartHour, lateShiftStartMin, lateShiftEndHour, lateShiftEndMin, lateShiftRestTime, nightShiftStartHour, nightShiftStartMin, nightShiftEndHour, nightShiftRestTime, nightShiftEndMin, dayShiftStartMin ]);

  // 就業期間チェック
  useEffect(() => {
    
    const validation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkSyuugyouKikan' ],
        target: { fromDate, toDate, pendingFromDateFlag, pendingToDateFlag },
      });
      console.log('valid:custom:checkSyuugyouKikan', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkSyuugyouKikan: { valid: isValid, errorMessages: newErrorMessages } };
      setValids(org => ({ ...org, ...newValid }));
    };

    validation();
  }, [ fromDate, pendingFromDateFlag, pendingToDateFlag, toDate ]);

  // 就業日数 > 就業曜日チェック
  useEffect(() => {
    
    const validation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkDayOfTheWeek' ],
        target: { minBusinessDay, dayOfTheWeek },
      });
      console.log('valid:custom:checkDayOfTheWeek', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkDayOfTheWeek: { valid: isValid, errorMessages: newErrorMessages } };
      setValids(org => ({ ...org, ...newValid }));
    };

    validation();
  }, [ minBusinessDay, dayOfTheWeek ]);

    
  // 日雇いチェック (終了時刻 - 開始時刻 - 休憩時間) * 就業日数(下限) < 20
  // 固定勤務
  useEffect(() => {
    
    const validation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkWeek20hour' ],
        target: { target: 'syuugyouTimeFixed', startHour: fixedStartHour, startMin: fixedStartMin, endHour: fixedEndHour, endMin: fixedEndMin, restTime: fixedRestTime, minBusinessDay },
      });
      console.log('valid:custom:checkWeek20hourFixed', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkWeek20hourFixed: { valid: isValid, errorMessages: newErrorMessages } };
      setFixedValids(org => ({ ...org, ...newValid }));
    };

    validation();
  }, [ fixedEndHour, fixedEndMin, fixedRestTime, fixedStartHour, fixedStartMin, minBusinessDay ]);
    
  // 終了時刻 - 開始時刻 - 休憩時間 > 8 チェック 
  // 固定勤務
  useEffect(() => {
    
    const over8HoursValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkOver8Hours' ],
        target: { target: 'syuugyouTimeFixed', startHour: fixedStartHour, startMin: fixedStartMin, endHour: fixedEndHour, endMin: fixedEndMin, restTime: fixedRestTime },
      });
      console.log('valid:custom:checkOver8HoursFixed', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkOver8HoursFixed: { valid: isValid, errorMessages: newErrorMessages } };
      setFixedValids(org => ({ ...org, ...newValid }));
    };

    const lessThan0HourValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkLessThan0Hour' ],
        target: { target: 'syuugyouTimeFixed', startHour: fixedStartHour, startMin: fixedStartMin, endHour: fixedEndHour, endMin: fixedEndMin, restTime: fixedRestTime },
      });
      console.log('valid:custom:checkLessThan0HourFixed', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkLessThan0HourFixed: { valid: isValid, errorMessages: newErrorMessages } };
      setFixedValids(org => ({ ...org, ...newValid }));
    };

    over8HoursValidation();
    lessThan0HourValidation();

  }, [ fixedEndHour, fixedEndMin, fixedRestTime, fixedStartHour, fixedStartMin ]);

  // 終了時刻 - 開始時刻 - 休憩時間 > 8 チェック
  // 早番
  useEffect(() => {
    
    const over8HoursValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkOver8Hours' ],
        target: { target: 'syuugyouTimeEarlyShift', startHour: earlyShiftStartHour, startMin: earlyShiftStartMin, endHour: earlyShiftEndHour, endMin: earlyShiftEndMin, restTime: earlyShiftRestTime },
      });
      console.log('valid:custom:checkOver8HoursEarlyShift', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkOver8HoursEarlyShift: { valid: isValid, errorMessages: newErrorMessages } };
      setEarlyShiftValids(org => ({ ...org, ...newValid }));
    };
    const lessThan0HourValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkLessThan0Hour' ],
        target: { target: 'syuugyouTimeEarlyShift', startHour: earlyShiftStartHour, startMin: earlyShiftStartMin, endHour: earlyShiftEndHour, endMin: earlyShiftEndMin, restTime: earlyShiftRestTime },
      });
      console.log('valid:custom:checkLessThan0HourEarlyShift', { isValid, newErrorMessages });

      // erros更新
      const newValid = { checkLessThan0HourEarlyShift: { valid: isValid, errorMessages: newErrorMessages } };
      setEarlyShiftValids(org => ({ ...org, ...newValid }));
    };

    over8HoursValidation();
    lessThan0HourValidation();

  }, [ earlyShiftEndHour, earlyShiftEndMin, earlyShiftRestTime, earlyShiftStartHour, earlyShiftStartMin ]);

  // 終了時刻 - 開始時刻 - 休憩時間 > 8 チェック
  // 日勤
  useEffect(() => {
    
    const over8HoursValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkOver8Hours' ],
        target: { target: 'syuugyouTimeDayShift', startHour: dayShiftStartHour, startMin: dayShiftStartMin, endHour: dayShiftEndHour, endMin: dayShiftEndMin, restTime: dayShiftRestTime },
      });
      console.log('valid:custom:checkOver8HoursDayShift', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkOver8HoursDayShift: { valid: isValid, errorMessages: newErrorMessages } };
      setDayShiftValids(org => ({ ...org, ...newValid }));
    };
    const lessThan0HourValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkLessThan0Hour' ],
        target: { target: 'syuugyouTimeDayShift', startHour: dayShiftStartHour, startMin: dayShiftStartMin, endHour: dayShiftEndHour, endMin: dayShiftEndMin, restTime: dayShiftRestTime },
      });
      console.log('valid:custom:checkLessThan0HourDayShift', { isValid, newErrorMessages });

      // erros更新
      const newValid = { checkLessThan0HourDayShift: { valid: isValid, errorMessages: newErrorMessages } };
      setDayShiftValids(org => ({ ...org, ...newValid }));
    };

    over8HoursValidation();
    lessThan0HourValidation();
  }, [ dayShiftEndHour, dayShiftEndMin, dayShiftRestTime, dayShiftStartHour, dayShiftStartMin ]);

  // 終了時刻 - 開始時刻 - 休憩時間 > 8 チェック
  // 遅番
  useEffect(() => {
    
    const over8HoursValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkOver8Hours' ],
        target: { target: 'syuugyouTimeLateShift', startHour: lateShiftStartHour, startMin: lateShiftStartMin, endHour: lateShiftEndHour, endMin: lateShiftEndMin, restTime: lateShiftRestTime },
      });
      console.log('valid:custom:checkOver8HoursLateShift', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkOver8HoursLateShift: { valid: isValid, errorMessages: newErrorMessages } };
      setLateShiftValids(org => ({ ...org, ...newValid }));
    };
    const lessThan0HourValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkLessThan0Hour' ],
        target: { target: 'syuugyouTimeLateShift', startHour: lateShiftStartHour, startMin: lateShiftStartMin, endHour: lateShiftEndHour, endMin: lateShiftEndMin, restTime: lateShiftRestTime },
      });
      console.log('valid:custom:checkLessThan0HourLateShift', { isValid, newErrorMessages });

      // erros更新
      const newValid = { checkLessThan0HourLateShift: { valid: isValid, errorMessages: newErrorMessages } };
      setLateShiftValids(org => ({ ...org, ...newValid }));
    };

    over8HoursValidation();
    lessThan0HourValidation();
  }, [ lateShiftEndHour, lateShiftEndMin, lateShiftRestTime, lateShiftStartHour, lateShiftStartMin ]);

  // 終了時刻 - 開始時刻 - 休憩時間 > 8 チェック
  // 夜勤
  useEffect(() => {
    
    const over8HoursValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkOver8Hours' ],
        target: { target: 'syuugyouTimeNightShift', startHour: nightShiftStartHour, startMin: nightShiftStartMin, endHour: nightShiftEndHour, endMin: nightShiftEndMin, restTime: nightShiftRestTime },
      });
      console.log('valid:custom:checkOver8HoursNightShift', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkOver8HoursNightShift: { valid: isValid, errorMessages: newErrorMessages } };
      setNightShiftValids(org => ({ ...org, ...newValid }));
    };
    const lessThan0HourValidation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkLessThan0Hour' ],
        target: { target: 'syuugyouTimeNightShift', startHour: nightShiftStartHour, startMin: nightShiftStartMin, endHour: nightShiftEndHour, endMin: nightShiftEndMin, restTime: nightShiftRestTime },
      });
      console.log('valid:custom:checkLessThan0HourNightShift', { isValid, newErrorMessages });

      // erros更新
      const newValid = { checkLessThan0HourNightShift: { valid: isValid, errorMessages: newErrorMessages } };
      setNightShiftValids(org => ({ ...org, ...newValid }));
    };

    over8HoursValidation();
    lessThan0HourValidation();
  }, [ nightShiftEndHour, nightShiftEndMin, nightShiftRestTime, nightShiftStartHour, nightShiftStartMin ]);
  
  // 勤務時間が6時間を超える場合  休憩時間 >= 45分 チェック - 固定勤務
  useEffect(() => {
    const validation = async () => {
      // エラーチェックを実行
      const target = isSp ? 'restTimeFixed' : 'syuugyouTimeFixed';
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkRestTime' ],
        target: { target, startHour: fixedStartHour, startMin: fixedStartMin, endHour: fixedEndHour, endMin: fixedEndMin, restTime: fixedRestTime, isSp },
      });
      console.log('valid:custom:checkRestTimeFixed', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkRestTimeFixed: { valid: isValid, errorMessages: newErrorMessages } };
      setFixedValids(org => ({ ...org, ...newValid }));
    };

    validation();
  }, [ fixedEndHour, fixedEndMin, fixedRestTime, fixedStartHour, fixedStartMin, isSp ]);

  // 勤務時間が6時間を超える場合  休憩時間 >= 45分 チェック - 早番
  useEffect(() => {
    const validation = async () => {
      // エラーチェックを実行
      const target = isSp ? 'restTimeEarlyShift' : 'syuugyouTimeEarlyShift';
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkRestTime' ],
        target: { target, startHour: earlyShiftStartHour, startMin: earlyShiftStartMin, endHour: earlyShiftEndHour, endMin: earlyShiftEndMin, restTime: earlyShiftRestTime, isSp },
      });
      console.log('valid:custom:checkRestTimeEarlyShift', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkRestTimeEarlyShift: { valid: isValid, errorMessages: newErrorMessages } };
      setEarlyShiftValids(org => ({ ...org, ...newValid }));
    };

    validation();
  }, [ earlyShiftEndHour, earlyShiftEndMin, earlyShiftRestTime, earlyShiftStartHour, earlyShiftStartMin, isSp ]);

  // 勤務時間が6時間を超える場合  休憩時間 >= 45分 チェック - 日勤
  useEffect(() => {
    const validation = async () => {
      // エラーチェックを実行
      const target = isSp ? 'restTimeDayShift' : 'syuugyouTimeDayShift';
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkRestTime' ],
        target: { target, startHour: dayShiftStartHour, startMin: dayShiftStartMin, endHour: dayShiftEndHour, endMin: dayShiftEndMin, restTime: dayShiftRestTime, isSp },
      });
      console.log('valid:custom:checkRestTimeDayShift', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkRestTimeDayShift: { valid: isValid, errorMessages: newErrorMessages } };
      setDayShiftValids(org => ({ ...org, ...newValid }));
    };

    validation();
  }, [ dayShiftEndHour, dayShiftEndMin, dayShiftRestTime, dayShiftStartHour, dayShiftStartMin, isSp ]);

  // 勤務時間が6時間を超える場合  休憩時間 >= 45分 チェック - 遅番
  useEffect(() => {
    const validation = async () => {
      // エラーチェックを実行
      const target = isSp ? 'restTimeLateShift' : 'syuugyouTimeLateShift';
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkRestTime' ],
        target: { target, startHour: lateShiftStartHour, startMin: lateShiftStartMin, endHour: lateShiftEndHour, endMin: lateShiftEndMin, restTime: lateShiftRestTime, isSp },
      });
      console.log('valid:custom:checkRestTimeLateShift', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkRestTimeLateShift: { valid: isValid, errorMessages: newErrorMessages } };
      setLateShiftValids(org => ({ ...org, ...newValid }));
    };

    validation();
  }, [ isSp, lateShiftEndHour, lateShiftEndMin, lateShiftRestTime, lateShiftStartHour, lateShiftStartMin ]);

  // 勤務時間が6時間を超える場合  休憩時間 >= 45分 チェック - 夜勤
  useEffect(() => {
    const validation = async () => {
      // エラーチェックを実行
      const target = isSp ? 'restTimeNightShift' : 'syuugyouTimeNightShift';
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkRestTime' ],
        target: { target, startHour: nightShiftStartHour, startMin: nightShiftStartMin, endHour: nightShiftEndHour, endMin: nightShiftEndMin, restTime: nightShiftRestTime, isSp },
      });
      console.log('valid:custom:checkRestTimeNightShift', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkRestTimeNightShift: { valid: isValid, errorMessages: newErrorMessages } };
      setNightShiftValids(org => ({ ...org, ...newValid }));
    };

    validation();
  }, [ isSp, nightShiftEndHour, nightShiftEndMin, nightShiftRestTime, nightShiftStartHour, nightShiftStartMin ]);

  // 就業日数の相関チェック
  useEffect(() => {
    
    const validation = async () => {
      // エラーチェックを実行
      const [ isValid, newErrorMessages ] = await isCustomValid({
        checks: [ 'checkBusinessDay' ],
        target: { minBusinessDay, maxBusinessDay },
      });
      console.log('valid:custom:checkBusinessDay', { isValid, newErrorMessages });
      
      // erros更新
      const newValid = { checkBusinessDay: { valid: isValid, errorMessages: newErrorMessages } };
      setValids(org => ({ ...org, ...newValid }));
    };

    validation();
  }, [ minBusinessDay, maxBusinessDay ]);

  // 相場未満警告の相関チェック
  useEffect(() => {
    const newWarn = (!!suggestHourSalary && !!hourSalary ) 
      && !dispErrors().hourSalary
      && suggestHourSalary > hourSalary ?
      { hourSalary: CUSTOM_ERROR_MESSAGES.hourSalaryWarn } :
      { hourSalary: null };
    setWarn(org => ({ ...org, ...newWarn }));
  }, [ dispErrors, hourSalary, suggestHourSalary ]);

  // 相場未満警告の相関チェック
  useEffect(() => {
    const coefficient = calcSalaryCoefficient(qualification, qualificationText, experience);
    const newWarn = (!!suggestHourSalary && !!hourSalary ) 
      && !dispErrors().hourSalary
      && (suggestHourSalary + coefficient.min) > hourSalary ?
      { hourSalary: CUSTOM_ERROR_MESSAGES.hourSalaryWarn } :
      { hourSalary: null };
    setWarn(org => ({ ...org, ...newWarn }));
  }, [ dispErrors, experience, hourSalary, qualification, qualificationText, suggestHourSalary ]);

  // LP埋め込み時の高さ送信
  useEffect(() => {
    if(state.lpMode){
      postHeightToParent(state.lpOrigin, pageEl.current.clientHeight);
    }
  }, [ state.lpMode, state.lpOrigin, pageEl, workStyle, workStyleKbn ]);

  /* 
   * onChangeイベント群
   */
  // プルダウン両対応用
  const forHandleChange = clickVal => {
    return isSp ? clickVal.target.value : clickVal; 
  };
  // 就業期間の変更時
  const handleChangeFromDate = (e) => {
    const date = new Date (`${String(e).slice(0, 4)}/${String(e).slice(4, 6)}/${String(e).slice(6)}`);
    setMinToDate(typeOf(date) === 'date' ? 
      new Date(date.getFullYear(), date.getMonth(), date.getDate() + 31) :
      firstMinToDate);
    setPendingFromDateFlag(false);
    setFromDate(date);
  };
  const handleChangeToDate = (e) => {
    const date = new Date (`${String(e).slice(0, 4)}/${String(e).slice(4, 6)}/${String(e).slice(6)}`);
    console.log( date );
    setPendingToDateFlag(false);
    setToDate(date);
  };
  // 就業期間の「未定」選択時
  const handleChangeToDateFlag = (e) => {
    setPendingToDateFlag(e);
    setCalToPlaceholder(e ? '未定' : '');
    // クリア
    setToDate('');
  }; 
  const handleChangeFromDateFlag = (e) => {
    setPendingFromDateFlag(e);
    setCalFromPlaceholder(e ? '未定' : '');
    // クリア
    setFromDate('');
  }; 
  // 勤務形態の変更
  const handleChangeWorkStyle = ( e ) =>{
    setWorkStyle(e.target.value);
  };
  // 就業日数／週の変更時
  const handleChangeMinBusinessDay = clickVal =>{
    setMinBusinessDay(forHandleChange(clickVal));
  }; 
  // 就業日数／週の変更時
  const handleChangeMaxBusinessDay = clickVal =>{
    setMaxBusinessDay(forHandleChange(clickVal));
  }; 
  // 勤務曜日の変更時
  const handleChangeDayOfTheWeek = e => {
    const val = e.target.value;
    if (dayOfTheWeek.includes(val)) {
      setDayOfTheWeek(dayOfTheWeek.filter(item => item !== val));
    } else {
      setDayOfTheWeek([ ...dayOfTheWeek, val ]);
    }
  };
  // シフト区分選択時
  const handleChangeWorkStyleKbn = e => {
    const val = e.target.value;
    if (workStyleKbn.includes(val)) {
      setWorkStyleKbn(workStyleKbn.filter(item => item !== val));
    } else {
      setWorkStyleKbn([ ...workStyleKbn, val ]);
    }
    // シフト区分エラー表示トリガー
    if(!isShowError.workStyleKbn){
      setIsShowError({ ...isShowError, workStyleKbn: true });
    }
  };
  // 固定勤務
  // 就業時間（開始）の変更時
  const handleChangeFixedStartHour = clickVal => {
    setFixedStartHour(forHandleChange(clickVal));
  };
  const handleChangeFixedStartMin = clickVal => {
    setFixedStartMin(forHandleChange(clickVal));
  };
  // 就業時間（終了）の変更時
  const handleChangeFixedEndHour = clickVal => {
    setFixedEndHour(forHandleChange(clickVal));
  };
  const handleChangeFixedEndMin = clickVal => {
    setFixedEndMin(forHandleChange(clickVal));
  };
  // 休憩時間の変更時
  const handleChangeFixedRestTime = clickVal =>{
    setFixedRestTime(forHandleChange(clickVal));
  };
  // 早番
  // 就業時間（開始）の変更時
  const handleChangeEarlyShiftStartHour = clickVal => {
    setEarlyShiftStartHour(forHandleChange(clickVal));
  };
  const handleChangeEarlyShiftStartMin = clickVal => {
    setEarlyShiftStartMin(forHandleChange(clickVal));
  };
  // 就業時間（終了）の変更時
  const handleChangeEarlyShiftEndHour = clickVal => {
    setEarlyShiftEndHour(forHandleChange(clickVal));
  };
  const handleChangeEarlyShiftEndMin = clickVal => {
    setEarlyShiftEndMin(forHandleChange(clickVal));
  };
  // 休憩時間の変更時
  const handleChangeEarlyShiftRestTime = clickVal =>{
    setEarlyShiftRestTime(forHandleChange(clickVal));
  };
  // 日勤
  // 就業時間（開始）の変更時
  const handleChangeDayShiftStartHour = clickVal => {
    setDayShiftStartHour(forHandleChange(clickVal));
  };
  const handleChangeDayShiftStartMin = clickVal => {
    setDayShiftStartMin(forHandleChange(clickVal));
  };
  // 就業時間（終了）の変更時
  const handleChangeDayShiftEndHour = clickVal => {
    setDayShiftEndHour(forHandleChange(clickVal));
  };
  const handleChangeDayShiftEndMin = clickVal => {
    setDayShiftEndMin(forHandleChange(clickVal));
  };
  // 休憩時間の変更時
  const handleChangeDayShiftRestTime = clickVal =>{
    setDayShiftRestTime(forHandleChange(clickVal));
  };
  // 遅番
  // 就業時間（開始）の変更時
  const handleChangeLateShiftStartHour = clickVal => {
    setLateShiftStartHour(forHandleChange(clickVal));
  };
  const handleChangeLateShiftStartMin = clickVal => {
    setLateShiftStartMin(forHandleChange(clickVal));
  };
  // 就業時間（終了）の変更時
  const handleChangeLateShiftEndHour = clickVal => {
    setLateShiftEndHour(forHandleChange(clickVal));
  };
  const handleChangeLateShiftEndMin = clickVal => {
    setLateShiftEndMin(forHandleChange(clickVal));
  };
  // 休憩時間の変更時
  const handleChangeLateShiftRestTime = clickVal =>{
    setLateShiftRestTime(forHandleChange(clickVal));
  };
  // 夜勤
  // 就業時間（開始）の変更時
  const handleChangeNightShiftStartHour = clickVal => {
    setNightShiftStartHour(forHandleChange(clickVal));
  };
  const handleChangeNightShiftStartMin = clickVal => {
    setNightShiftStartMin(forHandleChange(clickVal));
  };
  // 就業時間（終了）の変更時
  const handleChangeNightShiftEndHour = clickVal => {
    setNightShiftEndHour(forHandleChange(clickVal));
  };
  const handleChangeNightShiftEndMin = clickVal => {
    setNightShiftEndMin(forHandleChange(clickVal));
  };
  // 休憩時間の変更時
  const handleChangeNightShiftRestTime = clickVal =>{
    setNightShiftRestTime(forHandleChange(clickVal));
  };

  // 画面項目の作成
  // 表示する文言,各state,各onChange
  const title = [ '勤務時間(早番)', '勤務時間(日勤)', '勤務時間(遅番)', '勤務時間(夜勤)' ];
  const startHourState = [ earlyShiftStartHour, dayShiftStartHour, lateShiftStartHour, nightShiftStartHour ];
  const startMinState = [ earlyShiftStartMin, dayShiftStartMin, lateShiftStartMin, nightShiftStartMin ];
  const endHourState = [ earlyShiftEndHour, dayShiftEndHour, lateShiftEndHour, nightShiftEndHour ];
  const endMinState = [ earlyShiftEndMin, dayShiftEndMin, lateShiftEndMin, nightShiftEndMin ];
  const RestTimeState = [ earlyShiftRestTime, dayShiftRestTime, lateShiftRestTime, nightShiftRestTime ];
  
  const startHourOnChange = [ handleChangeEarlyShiftStartHour, handleChangeDayShiftStartHour, handleChangeLateShiftStartHour, handleChangeNightShiftStartHour ];
  const startMinOnChange = [ handleChangeEarlyShiftStartMin, handleChangeDayShiftStartMin, handleChangeLateShiftStartMin, handleChangeNightShiftStartMin ];
  const endHourOnChange = [ handleChangeEarlyShiftEndHour, handleChangeDayShiftEndHour, handleChangeLateShiftEndHour, handleChangeNightShiftEndHour ];
  const endMinOnChange = [ handleChangeEarlyShiftEndMin, handleChangeDayShiftEndMin, handleChangeLateShiftEndMin, handleChangeNightShiftEndMin ];
  const RestTimeOnChange = [ handleChangeEarlyShiftRestTime, handleChangeDayShiftRestTime, handleChangeLateShiftRestTime, handleChangeNightShiftRestTime ];
  const errorDispMap = dispErrors();
  const syuugyouTimeErrors = [ errorDispMap.syuugyouTimeEarlyShift, errorDispMap.syuugyouTimeDayShift, errorDispMap.syuugyouTimeLateShift, errorDispMap.syuugyouTimeNightShift ];
  const restTimeErrors = [ errorDispMap.restTimeEarlyShift, errorDispMap.restTimeDayShift, errorDispMap.restTimeLateShift, errorDispMap.restTimeNightShift ];
  const ShiftTypeList = workStyleKbnList.map((value, idx) =>
    ({ value, title: title[idx], syuugyouTimeErrors: syuugyouTimeErrors[idx], restTimeErrors: restTimeErrors[idx],
      startHourState: startHourState[idx], startHourOnChange: startHourOnChange[idx],
      startMinState: startMinState[idx], startMinOnChange: startMinOnChange[idx],
      endHourState: endHourState[idx], endHourOnChange: endHourOnChange[idx],
      endMinState: endMinState[idx], endMinOnChange: endMinOnChange[idx],
      RestTimeState: RestTimeState[idx], RestTimeOnChange: RestTimeOnChange[idx],
    }));

  // 車通勤の変更
  const handleChangeCanCommuteByCar = clickVal => {
    setCanCommuteByCar(forHandleChange(clickVal));
  };
  // 時給の変更時
  const handleChangeHourSalary = (e)=>{
    setHourSalary(e.target.value);
    // エラー表示トリガー
    if(!isShowError.hourSalary){
      setIsShowError({ ...isShowError, hourSalary: true });
    }
  };

  // その他条件 フリーコメント変更時
  const handleChangeFreeComment = (e) =>{
    setFreeComment(e.target.value);
    // エラー表示トリガー
    if(!isShowError.freeComment){
      setIsShowError({ ...isShowError, freeComment: true });
    }
  };

  // ボタン押下
  // state更新処理
  const updateState = () => {
    dispatch({
      type: UPDATE_COND,
      updCond: { 
        fromDate,
        pendingFromDateFlag, // 未定
        toDate,
        pendingToDateFlag, // 未定
        workStyle,
        workStyleKbn,
        dayOfTheWeek,
        earlyShiftStartHour, // 早番
        earlyShiftStartMin,
        earlyShiftEndHour,
        earlyShiftEndMin,
        earlyShiftRestTime,
        dayShiftStartHour, // 日勤
        dayShiftStartMin,
        dayShiftEndHour,
        dayShiftEndMin,
        dayShiftRestTime,
        lateShiftStartHour, // 遅番
        lateShiftStartMin,
        lateShiftEndHour,
        lateShiftEndMin,
        lateShiftRestTime,
        nightShiftStartHour, // 夜勤
        nightShiftStartMin,
        nightShiftEndHour,
        nightShiftEndMin,
        nightShiftRestTime,
        fixedStartHour, // 固定勤務
        fixedStartMin,
        fixedEndHour,
        fixedEndMin,
        fixedRestTime,
        canCommuteByCar,
        hourSalary,
        minBusinessDay,
        maxBusinessDay,
        freeComment,
      },
    });
  };
  const onClickMainButton = {
    prev: () => {
      updateState();
    },
    next: () => {
      updateState();
      dispatch({
        type: CHANGE_VALID, 
        path,
        valid,
      });
    },
  };
  
  // 画面表示
  return(
    <div id='pageCond' ref={pageEl}>
      { isSp ? (
        <PresentSP 
          // 就業期間from 
          tommorow={tommorow}
          fromDate={fromDate}
          pendingFromDateFlag={pendingFromDateFlag}
          calFromPlaceholder={calFromPlaceholder}
          handleChangeFromDate={handleChangeFromDate}
          handleChangeFromDateFlag={handleChangeFromDateFlag}
          // 就業期間to 
          minToDate={minToDate}
          toDate={toDate}
          handleChangeToDate={handleChangeToDate}
          pendingToDateFlag={pendingToDateFlag}
          handleChangeToDateFlag={handleChangeToDateFlag}
          calToPlaceholder={calToPlaceholder}
          // 勤務形態
          workStyle={workStyle}
          handleChangeWorkStyle={handleChangeWorkStyle}
          workStyleList={workStyleList}
          // 就業日数 
          minBusinessDayList={minBusinessDayList}
          minBusinessDay={minBusinessDay}
          handleChangeMinBusinessDay={handleChangeMinBusinessDay}
          maxBusinessDayList={maxBusinessDayList}
          maxBusinessDay={maxBusinessDay}
          handleChangeMaxBusinessDay={handleChangeMaxBusinessDay}
          // 就業曜日 
          dayOfTheWeekList={dayOfTheWeekList}
          dayOfTheWeek={dayOfTheWeek}
          handleChangeDayOfTheWeek={handleChangeDayOfTheWeek}
          // シフト区分
          workStyleKbn={workStyleKbn}
          handleChangeWorkStyleKbn={handleChangeWorkStyleKbn}
          workStyleKbnList={workStyleKbnList}
          // 就業時間from 固定勤務
          startHourList={startHourList}
          fixedStartHour={fixedStartHour}
          handleChangeFixedStartHour={handleChangeFixedStartHour}
          startMinList={startMinList}
          fixedStartMin={fixedStartMin}
          handleChangeFixedStartMin={handleChangeFixedStartMin}
          // 就業時間to 固定勤務
          endHourList={endHourList}
          fixedEndHour={fixedEndHour}
          handleChangeFixedEndHour={handleChangeFixedEndHour}
          endMinList={endMinList}
          fixedEndMin={fixedEndMin}
          handleChangeFixedEndMin={handleChangeFixedEndMin}
          // 休憩時間 固定勤務
          restTimeList={restTimeList}
          fixedRestTime={fixedRestTime}
          handleChangeFixedRestTime={handleChangeFixedRestTime}
          // 就業時間 早番~夜勤
          ShiftTypeList={ShiftTypeList}
          // 車通勤
          canCommuteByCar={canCommuteByCar}
          handleChangeCanCommuteByCar={handleChangeCanCommuteByCar}
          canCommuteByCarList={canCommuteByCarList}
          // 時給、サジェスト 
          hourSalary={hourSalary}
          handleChangeHourSalary={handleChangeHourSalary}
          suggestHourSalaryDisp={suggestHourSalaryDisp}
          // その他条件
          freeComment={freeComment}
          handleChangeFreeComment={handleChangeFreeComment}
          // 更新、エラーチェック 
          onClickMainButton={onClickMainButton}
          valid={valid}
          errorDispMap={errorDispMap}
          warn={warn}
          lpMode={state.lpMode}
        />
      ) : (
        <PresentPC 
          // 就業期間from 
          tommorow={tommorow}
          fromDate={fromDate}
          pendingFromDateFlag={pendingFromDateFlag}
          calFromPlaceholder={calFromPlaceholder}
          handleChangeFromDate={handleChangeFromDate}
          handleChangeFromDateFlag={handleChangeFromDateFlag}
          // 就業期間to 
          minToDate={minToDate}
          toDate={toDate}
          handleChangeToDate={handleChangeToDate}
          pendingToDateFlag={pendingToDateFlag}
          handleChangeToDateFlag={handleChangeToDateFlag}
          calToPlaceholder={calToPlaceholder}
          // 勤務形態
          workStyle={workStyle}
          handleChangeWorkStyle={handleChangeWorkStyle}
          workStyleList={workStyleList}
          // 就業日数 
          minBusinessDayList={minBusinessDayList}
          minBusinessDay={minBusinessDay}
          handleChangeMinBusinessDay={handleChangeMinBusinessDay}
          maxBusinessDayList={maxBusinessDayList}
          maxBusinessDay={maxBusinessDay}
          handleChangeMaxBusinessDay={handleChangeMaxBusinessDay}
          // 就業曜日 
          dayOfTheWeekList={dayOfTheWeekList}
          dayOfTheWeek={dayOfTheWeek}
          handleChangeDayOfTheWeek={handleChangeDayOfTheWeek}
          // シフト区分
          workStyleKbn={workStyleKbn}
          handleChangeWorkStyleKbn={handleChangeWorkStyleKbn}
          workStyleKbnList={workStyleKbnList}
          // 就業時間from 固定勤務
          startHourList={startHourList}
          fixedStartHour={fixedStartHour}
          handleChangeFixedStartHour={handleChangeFixedStartHour}
          startMinList={startMinList}
          fixedStartMin={fixedStartMin}
          handleChangeFixedStartMin={handleChangeFixedStartMin}
          // 就業時間to 固定勤務
          endHourList={endHourList}
          fixedEndHour={fixedEndHour}
          handleChangeFixedEndHour={handleChangeFixedEndHour}
          endMinList={endMinList}
          fixedEndMin={fixedEndMin}
          handleChangeFixedEndMin={handleChangeFixedEndMin}
          // 休憩時間 
          restTimeList={restTimeList}
          fixedRestTime={fixedRestTime}
          handleChangeFixedRestTime={handleChangeFixedRestTime}
          // 就業時間 早番~夜勤
          ShiftTypeList={ShiftTypeList}
          // 車通勤
          canCommuteByCar={canCommuteByCar}
          handleChangeCanCommuteByCar={handleChangeCanCommuteByCar}
          canCommuteByCarList={canCommuteByCarList}
          // 時給、サジェスト 
          hourSalary={hourSalary}
          handleChangeHourSalary={handleChangeHourSalary}
          suggestHourSalaryDisp={suggestHourSalaryDisp}
          // その他条件
          freeComment={freeComment}
          handleChangeFreeComment={handleChangeFreeComment}      
          // 更新、エラーチェック 
          onClickMainButton={onClickMainButton}
          valid={valid}
          errorDispMap={errorDispMap}
          warn={warn}
          lpMode={state.lpMode}
        />
      )}
    </div>
  );
};

export default Cond;
